"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnector = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const _1 = require(".");
const core_1 = require("@web3-react/core");
const connectors_1 = require("./web3React/connectors");
const ai_1 = require("react-icons/ai");
const vsc_1 = require("react-icons/vsc");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const walletConnectorInterfaces_1 = require("./walletConnectorInterfaces");
const WalletConnector = ({ WalletConnectView, WalletConnectModal, WalletConnectViewProps, }) => {
    const [showWalletDialog, setShowWalletDialog] = (0, react_1.useState)(false);
    const [reconnect, setReconnect] = (0, react_1.useState)(false);
    const [networkClient, setNetworkClient] = (0, react_1.useState)(undefined);
    const [currentConnector, setCurrentConnector] = (0, react_1.useState)(0);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { active, activate, deactivate, library, account, chainId, error } = (0, core_1.useWeb3React)();
    const { isConnected, isConnecting, currentWalletNetwork, walletAddress, currentWallet, } = (0, react_redux_1.useSelector)((state) => state.walletConnector);
    let isAlgoConnected = false;
    const algoState = (0, react_redux_1.useSelector)((state) => state === null || state === void 0 ? void 0 : state.algorandWalletConnector);
    if (algoState) {
        isAlgoConnected = (algoState === null || algoState === void 0 ? void 0 : algoState.isAlgoConnected) || false;
    }
    (0, react_1.useEffect)(() => {
        if (isAlgoConnected) {
            // dispatch(algorandWalletConnectorActions.reconnectAlgorandWallet());
            connectAlgoWallet("TestNet");
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (account &&
            walletAddress &&
            walletAddress !== account &&
            isConnected &&
            active &&
            currentWallet !== 0) {
            // console.log("Account Changed reconnect wallet");
            activate(currentWallet === walletConnectorInterfaces_1.WALLET_TYPES.META_MASK ? connectors_1.injected : connectors_1.walletconnect);
            setCurrentConnector(currentWallet === walletConnectorInterfaces_1.WALLET_TYPES.META_MASK
                ? walletConnectorInterfaces_1.WALLET_TYPES.META_MASK
                : walletConnectorInterfaces_1.WALLET_TYPES.WALLET_CONNECT);
            setReconnect(true);
        }
        // eslint-disable-next-line
    }, [walletAddress, account, isConnected, active, currentWallet]);
    (0, react_1.useEffect)(() => {
        if (currentWallet === walletConnectorInterfaces_1.WALLET_TYPES.META_MASK) {
            connectors_1.injected
                .isAuthorized()
                .then((isAuthorized) => {
                // console.log(isAuthorized, active, "isAuthorized");
                if (isAuthorized && !active && !error && isConnected) {
                    activate(connectors_1.injected);
                    setCurrentConnector(walletConnectorInterfaces_1.WALLET_TYPES.META_MASK);
                }
            })
                .catch(() => { });
        }
    }, [activate, active, error, isConnected, currentWallet]);
    (0, react_1.useEffect)(() => {
        if (chainId &&
            currentWalletNetwork &&
            currentWalletNetwork !== chainId &&
            isConnected &&
            active &&
            currentWallet !== 0) {
            // console.log("Chain Changed reconnect wallet");
            activate(currentWallet === walletConnectorInterfaces_1.WALLET_TYPES.META_MASK ? connectors_1.injected : connectors_1.walletconnect);
            setCurrentConnector(currentWallet === walletConnectorInterfaces_1.WALLET_TYPES.META_MASK
                ? walletConnectorInterfaces_1.WALLET_TYPES.META_MASK
                : walletConnectorInterfaces_1.WALLET_TYPES.WALLET_CONNECT);
            setReconnect(true);
        }
        // eslint-disable-next-line
    }, [currentWalletNetwork, chainId, isConnected, active, currentWallet]);
    (0, react_1.useEffect)(() => {
        if (active && !isConnected && library && !networkClient) {
            // console.log("web3 react connect set network client");
            dispatch(_1.walletConnectorActions.connectWallet());
            setNetworkClient(library);
        }
        if (!active &&
            isConnected &&
            !library &&
            !isConnecting &&
            currentWallet !== 0) {
            // console.log("connected in currenct browser session reconnect wallet");
            activate(currentWallet === walletConnectorInterfaces_1.WALLET_TYPES.META_MASK ? connectors_1.injected : connectors_1.walletconnect);
            setCurrentConnector(currentWallet === walletConnectorInterfaces_1.WALLET_TYPES.META_MASK
                ? walletConnectorInterfaces_1.WALLET_TYPES.META_MASK
                : walletConnectorInterfaces_1.WALLET_TYPES.WALLET_CONNECT);
            setReconnect(true);
        }
        // eslint-disable-next-line
    }, [
        isConnected,
        active,
        library,
        isConnecting,
        networkClient,
        currentWallet,
    ]);
    (0, react_1.useEffect)(() => {
        if (reconnect && active) {
            // console.log(
            //   "reconnect called and web3 is active again reset network client to set again"
            // );
            dispatch(_1.walletConnectorActions.reconnectWallet());
            setNetworkClient(undefined);
            setReconnect(false);
        }
        // eslint-disable-next-line
    }, [reconnect, active]);
    // useEffect(()=>{
    // })
    (0, react_1.useEffect)(() => {
        if (active &&
            networkClient &&
            library &&
            !isConnected &&
            account &&
            chainId &&
            isConnecting
        // currentConnector !== 0
        ) {
            // console.log(
            //   "network client is set, web3 react is also active test by fetching account balance"
            // );
            networkClient.eth
                .getBalance(account === null || account === void 0 ? void 0 : account.toString())
                .then((balance) => {
                // console.log(
                //   "newtork ping completed successfully update redux with wallet and network client information"
                // );
                dispatch(_1.walletConnectorActions.walletConnected({
                    chainId,
                    account,
                    balance,
                    currentWallet: currentConnector,
                    networkClient,
                }));
            })
                .catch((err) => {
                // console.log("newtork ping failed reset wallet state");
                // console.log(err, " : error connecting wallet");
                react_hot_toast_1.default.error(err || "Error connecting wallet");
                dispatch(_1.walletConnectorActions.resetWalletConnector());
            });
        }
        // eslint-disable-next-line
    }, [
        networkClient,
        library,
        isConnected,
        active,
        account,
        chainId,
        isConnecting,
        currentConnector,
    ]);
    const openWalletSelectorDialog = () => {
        setShowWalletDialog(true);
        // console.log("open wallet selector to connect");
        // if (!isConnecting) {
        //   if (!isConnected) {
        //     setShowWalletDialog(true);
        //   } else {
        //     // console.log("wallet is already connect disconnect wallet");
        //     dispatch(walletConnectorActions.resetWalletConnector());
        //     setNetworkClient(undefined);
        //     deactivate();
        //   }
        // } else {
        //   // console.log("wallet is already in connect state");
        // }
    };
    // console.log(isConnecting, "isConnecting");
    // console.log(isConnected, "isConnected");
    // console.log(active, "active");
    // console.log(library, "library");
    // console.log(networkClient, "networkClient");
    // console.log(walletAddress, "walletAddress");
    // console.log(account, "account");
    // console.log(walletAddress === account);
    // console.log(chainId, "chainId");
    // console.log(currentWalletNetwork, "currentWalletNetwork");
    // console.log(currentWalletNetwork === chainId);
    // console.log("currentWallet", currentWallet);
    // console.log("currentConnector", currentConnector);
    // console.log(error);
    const connectWallet = (connector) => {
        if (isConnected) {
            // console.log("wallet is already connect disconnect wallet");
            dispatch(_1.walletConnectorActions.resetWalletConnector());
            setNetworkClient(undefined);
            deactivate();
            setCurrentConnector(0);
        }
        else {
            // console.log("intialize web3 wallet connect for meta mask");
            activate(connector === walletConnectorInterfaces_1.WALLET_TYPES.META_MASK ? connectors_1.injected : connectors_1.walletconnect);
            // setShowWalletDialog(false);
            setNetworkClient(undefined);
            setCurrentConnector(connector === walletConnectorInterfaces_1.WALLET_TYPES.META_MASK
                ? walletConnectorInterfaces_1.WALLET_TYPES.META_MASK
                : walletConnectorInterfaces_1.WALLET_TYPES.WALLET_CONNECT);
        }
    };
    const connectAlgoWallet = (ledger) => __awaiter(void 0, void 0, void 0, function* () {
        const { AlgoSigner } = window;
        if (AlgoSigner) {
            // console.log(AlgoSigner);
            dispatch(_1.algorandWalletConnectorActions.algorandConnectWallet());
            yield AlgoSigner.connect({
                ledger: ledger,
            })
                .then((result) => __awaiter(void 0, void 0, void 0, function* () {
                // console.log(result);
                let algorandPayload = {
                    walletAddresses: [],
                    networkClient: AlgoSigner,
                };
                algorandPayload.walletAddresses = yield AlgoSigner.accounts({
                    ledger: ledger,
                });
                // console.log(algorandPayload);
                dispatch(_1.algorandWalletConnectorActions.algorandWalletConnected(algorandPayload));
            }))
                .catch((error) => {
                dispatch(_1.algorandWalletConnectorActions.disconnectAlgorandWallet());
            });
        }
        else {
            react_hot_toast_1.default.error("Algorand not found in browser");
        }
    });
    const disconnectAlgoWallet = () => {
        dispatch(_1.algorandWalletConnectorActions.disconnectAlgorandWallet());
    };
    (0, react_1.useEffect)(() => {
        if (error) {
            dispatch(_1.walletConnectorActions.resetWalletConnector());
            // console.log(error);
            react_hot_toast_1.default.error((error === null || error === void 0 ? void 0 : error.message) || "Error connecting wallet");
            // deactivate();
        }
        // eslint-disable-next-line
    }, [error]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(WalletConnectView, Object.assign({}, Object.assign(Object.assign({}, WalletConnectViewProps), { prefix: Object.assign({}, (isConnecting ? (react_1.default.createElement(ai_1.AiOutlineLoading3Quarters, null)) : !isConnected ? (react_1.default.createElement(vsc_1.VscDebugDisconnect, null)) : (react_1.default.createElement(ai_1.AiOutlineDisconnect, null)))), title: "Wallet", disabled: isConnecting }), { onClick: () => {
                openWalletSelectorDialog();
            } })),
        react_1.default.createElement(WalletConnectModal, { show: showWalletDialog, metaMaskClickEvent: () => {
                connectWallet(walletConnectorInterfaces_1.WALLET_TYPES.META_MASK);
            }, walletConnectClickEvent: () => {
                connectWallet(walletConnectorInterfaces_1.WALLET_TYPES.WALLET_CONNECT);
            }, algorandWalletClickEvent: () => {
                isAlgoConnected
                    ? disconnectAlgoWallet()
                    : connectAlgoWallet("TestNet");
            }, selectAlgorandWalletAddress: (value) => dispatch(_1.algorandWalletConnectorActions.connectAlgorandWalletAddress(value)), onHide: () => setShowWalletDialog(false) })));
};
exports.WalletConnector = WalletConnector;
//# sourceMappingURL=wallet-connector.js.map